import { makeStyles } from '@material-ui/core/styles';

export const useLogoutButtonStyles = makeStyles(() => ({
  container: {
    position: 'absolute',
    right: 0,
  },
  button: {
    color: 'white',
  },
}));
